import React from 'react';
import { IconButton } from 'styled_components/Common/IconButton';
import { BloxButton } from 'styled_components/Common/BloxButton';
import ReactHtmlParser from 'react-html-parser';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { string, func, bool, object } from 'prop-types';
import styled from 'styled-components';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;

const PopUpContainer = styled.div`
	.pop-up {
		width: 200px;
		box-shadow: 0 0 35px 0 ${props => props.theme.boxShadow};
		color: ${props => props.theme.defaultFontColor};
		.pop-up-header {
			position: relative;
			height: 40px;
			background: ${props => props.theme.Cool_Gray_Light_1};
			.exit-modal {
				width: 24px;
				height: 24px;
				position: absolute;
				bottom: 8px;
				right: 16px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 12px;
					height: 12px;
				}
			}
		}
		.pop-up-body {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 84px;
			padding: 8px 16px 8px;
			background: ${props => props.theme.Cool_Gray_Light_3};
			.ScrollbarsCustom-Track {
				right: -10px !important;
				top: 0px !important;
			}
			.ScrollbarsCustom-ThumbY {
				background-color: ${props => props.theme.support} !important;
				width: 6px !important;
			}
			.ScrollbarsCustom-TrackY:before {
				border-left: none;
			}
			.ScrollbarsCustom-TrackY {
				background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
				width: 6px !important;
			}
			.content {
				text-align: center;
				overflow-wrap: break-word;
				width: 100%;
				img {
					width: 19px;
					height: 19px;
				}
			}
		}
		.pop-up-footer {
			display: flex;
			align-items: center;
			justify-content: center;
			background: ${props => props.theme.white};
			height: 48px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.pop-up {
			width: 256px;
			.pop-up-header {
				height: 40px;

				.exit-modal {
					width: 24px;
					height: 24px;
					position: absolute;
					bottom: 8px;
					right: 16px;
					#icon-button {
						width: 24px !important;
						height: 24px !important;
					}

					img {
						width: 12px;
						height: 12px;
					}
				}
			}
			.pop-up-body {
				height: 112px;
				padding: 16px 24px 16px;
			}
			.pop-up-footer {
				height: 64px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.pop-up {
			width: 432px;
			.pop-up-header {
				height: 64px;

				.exit-modal {
					width: 40px;
					height: 40px;
					position: absolute;
					bottom: 8px;
					right: 24px;

					img {
						width: 12px;
						height: 12px;
					}
				}
			}
			.pop-up-body {
				height: 184px;
				padding: 16px 24px 16px;
				.content {
					img {
						width: 30px;
						height: 30px;
						margin-right: 10px;
					}
				}
			}
			.pop-up-footer {
				height: 88px;
			}
		}
	}
`;

export const PopUp = ({
	showModal,
	cypressId,
	id,
	closeModal,
	title,
	text,
	footer,
	customBody,
}) => {
	console.log(customBody);
	return (
		<PopUpContainer
			id={id}
			className={showModal ? 'show modal-background' : 'modal-background'}
			data-cy={cypressId}
		>
			<div className='pop-up'>
				<div className='pop-up-header'>
					<div className='exit-modal' style={{ cursor: 'pointer' }} onClick={closeModal}>
						<IconButton
							enabled={true}
							id='icon-button'
							module={module}
							style={{ cursor: 'pointer' }}
						>
							<img data-cy='close-button' src={CloseIcon} alt='' />
						</IconButton>
					</div>
				</div>
				<div className='pop-up-body'>
					<ScrollView>
						<div className='content body10'>
							{title && <div className='title body10'>{title}</div>}
							{!customBody && <div className='text body10'>{text}</div>}
							{customBody && ReactHtmlParser(customBody)}
						</div>
					</ScrollView>
				</div>
				<div className='pop-up-footer'>{footer}</div>
			</div>
		</PopUpContainer>
	);
};

PopUp.propTypes = {
	showModal: bool,
	id: string,
	closeModal: func.isRequired,
	onClick: func,
	title: string,
	text: string,
	cypressId: string,
	footer: object,
};

PopUp.defaultProps = {
	showModal: false,
	id: '',
	onClick: () => {},
	title: 'Modal Title',
	text: 'Modal text',
	cypressId: 'pop-up-modal',
	footer: (
		<BloxButton
			className='buttons41'
			id='okay'
			text='OKAY'
			module='support'
			enabled={true}
			onClick={() => {}}
			cypressId='okay'
		/>
	),
};
